import React, { useState } from 'react';
import '../blocks/ModernBlocks.css';

const BeforeAfterBlock = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="before-after-section">
      <div className="before-after-container">
        <div className="before-after-header">
          <h2 className="before-after-title">{data.title}</h2>
          <p className="before-after-subtitle">{data.subtitle}</p>
        </div>
        
        <div className="before-after-content">
          {data.items.map((item, index) => (
            <div 
              key={index} 
              className={`before-after-item ${index === activeIndex ? 'active' : ''}`}
            >
              <div className="before-after-images">
                <div className="before-after-slider">
                  <div className="before-image">
                    <img src={item.beforeImage} alt={`Before - ${item.title}`} />
                    <div className="image-label before-label">Before</div>
                  </div>
                  <div className="after-image">
                    <img src={item.afterImage} alt={`After - ${item.title}`} />
                    <div className="image-label after-label">After</div>
                  </div>
                  <div className="slider-handle">
                    <div className="slider-line"></div>
                    <div className="slider-circle">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="before-after-info">
                <h3 className="before-after-item-title">{item.title}</h3>
                <p className="before-after-item-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="before-after-navigation">
          {data.items.map((_, index) => (
            <button
              key={index}
              className={`nav-dot ${index === activeIndex ? 'active' : ''}`}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterBlock; 